import GambleModel from "slotworks/model/gamble/gamble-model";
import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import GambleRequestPayload from "slotworks/model/gameplay/requests/gamble-request-payload";
import CommsManager from "slotworks/server/comms-manager";
import Contract from "slotworks/utils/contracts/contract";

export function GambleSendCommand(): Contract<void> {
    const payload = new GambleRequestPayload();
    payload.id = (GameState.getCurrentGame().getCurrentRecord() as SpinRecord).gambleID;
    payload.choice = GambleModel.getCurrentChoice();

    return CommsManager.request(payload);
}
